import * as React from 'react';

import {
  GenericFlyoutListMenuWidget,
  GenericMenuItemInfo
} from '@tableau/widgets';

import { CommonStyles } from '../../../common/react/CommonStyles';

// Not sure why this isn't exported from shared widgets.  Copied entire thing here for now
// import { DisplayValueFormatterProps } from '@tableau/widgets/lib/src/widgets/ListMenuDisplayFormatters/DisplayValueFormatter';
export interface DisplayValueFormatterProps {
  readonly disabled?: boolean;
  readonly active?: boolean;
  readonly checked?: boolean;
  readonly showCheckGutter?: boolean;
  readonly isHighlighted?: boolean;
  readonly hasSubMenu?: boolean;
  readonly testId: string;
}

export interface ExplorerListMenuPanelStateProps {
  menuItems: GenericMenuItemInfo[];
}

export interface ExplorerListMenuPanelDispatchProps {
  onComponentDidUpdate: () => void;
}

export interface ExplorerListMenuPanelOwnProps {
  anchorEl: HTMLElement;
  testId: string;
  onCloseRequest: () => void;
  onSelect: (value: string) => void;
  width?: number;
}

export type ExplorerListMenuPanelProps = ExplorerListMenuPanelStateProps
  & ExplorerListMenuPanelDispatchProps & ExplorerListMenuPanelOwnProps;

export class ExplorerListMenuPanel extends React.PureComponent<ExplorerListMenuPanelProps> {

  public componentDidMount(): void {
    // We want to update on mount as well
    this.props.onComponentDidUpdate();
  }

  public componentDidUpdate(): void {
    this.props.onComponentDidUpdate();
  }

  public render(): JSX.Element {
    return (
      <GenericFlyoutListMenuWidget
          menuStyle={{width: this.props.width, fontWeight: 'normal', top: '-1px'}}
          menuItemInfos={this.props.menuItems}
          onSelect={this.props.onSelect}
          anchorEl={this.props.anchorEl}
          testId={this.props.testId}
          toggleEl={this.props.anchorEl}
          handleScrollOnScrollingRoot={this.props.onCloseRequest}
          requestCloseAll={this.props.onCloseRequest}
          topFromOverlaidPosition={-1}
          allowAutoPosition={true}
          shouldReturnFocusToToggleEl={false}
        />
    );
  }
}
